<template>
  <div v-if="flashMessage" v-bind:class="cs">
    {{ flashMessage }}
  </div>
</template>
<script>
import { ref,computed } from "vue";
import { useStore } from "vuex";

export default {
  props: {
    color: String
  },
  setup(props) {
    const store = useStore();
    const cs = ref("notification is-light " + props.color);
    const flashMessage = ref(
      computed(() => {
        let message = store.getters.message;
        store.commit("unsetMessage");
        return message;
      })
    );
    return {
      flashMessage,
      cs,
    };
  },
};
</script>
